/**
 * Language the assistant replies in, toward the account's leads.
 *
 * Deliberately separate from `uiLanguage.ts`: that one is the operator's interface language.
 * A Brazilian agency can run the interface in English and keep serving leads in Portuguese,
 * and one account can have a Spanish assistant next to a Portuguese one.
 */

export type AssistantResponseLanguage = 'pt-BR' | 'en' | 'es'

export const DEFAULT_ASSISTANT_RESPONSE_LANGUAGE: AssistantResponseLanguage = 'pt-BR'

export const ASSISTANT_RESPONSE_LANGUAGE_OPTIONS: ReadonlyArray<{
  value: AssistantResponseLanguage
  label: string
}> = [
  { value: 'pt-BR', label: 'Português (Brasil)' },
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Español' },
]

export function isAssistantResponseLanguage(value: unknown): value is AssistantResponseLanguage {
  return value === 'pt-BR' || value === 'en' || value === 'es'
}
